import { useCallback, useMemo, useState } from 'react';

function useDefaultModal() {
    const [dataModal, setDataModal] = useState({ show: false, type: '', message: '', onClose: null });

    const showDefaultModal = useCallback((type, message, onClose = null) => {
        setDataModal({ show: true, type, message, onClose });
    }, []);

    const closeDefaultModal = useCallback(() => {
        setDataModal(prevModalData => {
            if (prevModalData.onClose && prevModalData.type === 'success') {
                prevModalData.onClose(); // Executa a ação apenas para mensagens de sucesso
            }
            return { ...prevModalData, show: false, onClose: null };
        });
    }, []);

    const setDefaultModal = useMemo(() => ({
        show: dataModal.show,
        type: dataModal.type,
        message: dataModal.message,
        onClose: closeDefaultModal
    }), [closeDefaultModal, dataModal.message, dataModal.show, dataModal.type]);

    return {
        setDefaultModal,
        showDefaultModal,

    };
}

export default useDefaultModal;
